<template>
  <div class="icon-host" ref="host">
    <slot />
  </div>
</template>
<script lang="ts" setup>
import { useMap } from "../../composables/use-map";
import type { Map } from "mapbox-gl";

const host = ref();
const map = useMap() as Ref<Map>;
const props = defineProps<{
  as: string;
}>();

function svgString2Image(
  svgString: string,
  width: number,
  height: number
): Promise<ImageData> {
  return new Promise((resolve, reject) => {
    // SVG data URL from SVG string
    var svgData =
      "data:image/svg+xml;base64," +
      btoa(unescape(encodeURIComponent(svgString)));

    // create canvas in memory(not in DOM)
    var canvas = document.createElement("canvas");

    // get canvas context for drawing on canvas
    var context = canvas.getContext("2d");
    // set canvas size
    canvas.width = width;
    canvas.height = height;
    // create image in memory(not in DOM)
    var image = new Image();

    // later when image loads run this
    image.onload = function () {
      // async (happens later)
      // clear canvas
      context.clearRect(0, 0, width, height);
      // draw image with SVG data to canvas
      context.drawImage(image, 0, 0, width, height);

      resolve(context.getImageData(0, 0, width, height));
    };

    image.onerror = reject;
    // start loading SVG data into in memory image
    image.src = svgData;
  });
}

onMounted(async () => {
  const svg = host.value.querySelector("svg") as SVGElement;
  if (!svg) {
    console.error("No svg found");
    return;
  }

  const viewBox = svg.getAttribute("viewBox")!;
  const viewBoxParsed = viewBox.split(/\s+/).map((m) => parseInt(m));

  const width = viewBoxParsed[2];
  const height = viewBoxParsed[3];

  const innards = svg.innerHTML;
  const color = svg.style.color;

  const image = await svgString2Image(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${viewBox}" width="${width}" height="${height}">${innards.replaceAll(
      "currentColor",
      color
    )}</svg>`,
    width,
    height
  );

  if (map.value?.hasImage(props.as)) map.value?.updateImage(props.as, image);
  else map.value?.addImage(props.as, image);
});
</script>
<style scoped>
.icon-host {
  display: none;
}
</style>
